import styled, { css } from 'styled-components';
import { ActionButton, BasePaginatorHeader, BasePaginatorListItem } from 'styles/components';

export {
  PaginatorColumn as Column,
  PaginatorActionsColumn as ActionsColumn,
  ActionButton,
  LinkActionButton,
  EditIcon,
  LockIcon,
  EyeIcon,
} from 'styles/components';

export const List = styled.div`
  display: flex;
  flex-direction: column;
`;

const baseGridCss = css`
  grid-template-columns: 60px 200px 200px 1fr 180px 80px;
`;

export const ListHeader = styled(BasePaginatorHeader)`
  ${baseGridCss}
`;

export const ListItem = styled(BasePaginatorListItem)`
  ${baseGridCss}
`;

export const ViewButton = styled(ActionButton)``;